/** Conversational UI assistant domain storage. Cross-tab (localStorage) open flag and current conversation id. */
import Storage from '../index';
import StorageKeys from '../keys';

const conversational = {
    isChatOpen: () => Storage.getRaw(StorageKeys.conversationalChatOpen) === 'true',
    setChatOpen: (open) => Storage.setRaw(StorageKeys.conversationalChatOpen, open ? 'true' : 'false'),

    getChatId: () => Storage.getRaw(StorageKeys.conversationalChatId),
    setChatId: (chatId) => Storage.setRaw(StorageKeys.conversationalChatId, chatId),
    clearChatId: () => Storage.remove(StorageKeys.conversationalChatId),
};

export default conversational;
